export const chartColors = {
  chartblue_1: "#c7d2fe",
  chartblue_2: "#a5b4fc",
  chartblue_3: "#818cf8",
};
